// IMPORTANT: Build gql after ANY changes to queries (client OR api)

import { graphql } from '@/client/services/api/graphql/gql';

export const getWorkflowStatsQuery: any = graphql(`
  query GetWorkflowStats($id: String!) {
    workflowStats(id: $id) {
      completedLate
      completedOnTime
      completedPercentage
      inProgress
      notStarted
      openAssignments
      overdue
      overduePercentage
      pendingOnTime
      totalAssignments
      totalGroups
    }
  }
`);
